module.exports = __webpack_public_path__ + "img/quility-form.2a946bef.png";